<template>
    <div class="header">
        <div>
            <div>
                <div v-if="$route.meta.isHeaderLeft" @click="home">瑞阳首页</div>
            </div>
            <div v-if="!$route.meta.isHeaderLeft">
                <div @click="home">瑞阳首页</div>
                <div class="login" v-if="!$store.state.userId">
                    <div @click="login">登录</div>
                    <div>｜</div>
                    <div @click="register">注册</div>
                </div>
                <div class="user" v-if="$store.state.userId" @click="goRouter('/me')">
                    <div><i class="el-icon-user"></i>{{$store.state.nickname}}</div>
                </div>
                <div v-if="$store.state.userId" @click="goRouter('/my_order')">我的订单</div>
                <!-- <div>手机版下载</div> -->
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Header",
        data() {
            return {}
        },
        methods: {
            home() {
                this.$router.push({
                    path: '/'
                })
            },
            login() {
                this.$router.push({
                    path: '/login'
                })
            },
            register() {
                this.$router.push({
                    path: '/register'
                })
            }
        }
    };
</script>

<style scoped>
    .header {
        height: 50px;
        background: #EAEAEA;
    }

    .header>div {
        width: 1200px;
        height: 50px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        line-height: 50px;
        color: #D50101;
        font-size: 14px;
        font-weight: 400;
    }

    .header>div>div {
        display: flex;
        justify-content: flex-end;
    }

    .header>div>div>div {
        margin-right: 32px;
        cursor: pointer;
    }

    .header>div>div>div:last-child {
        margin-right: 0;
    }

    .header .login {
        display: flex;
    }

    .header .login>div:nth-child(2) {
        margin: 0 6px;
        line-height: 48px;
    }

    .header .login>div:nth-child(3) {
        color: #D50101;
    }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue